<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <!-- {{se_pengeluaran}} -->
            <w-input class="mt4" label="Tarikh Pendaftaran*" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
            <!-- <template v-if="form.id == 0"> -->
            <z-select class="mt4" :items="adhoc" @input="getKatalog" label="Sumber *"  v-model="form.adhoc" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <!-- <template v-if="$zutil.anyRole(['1', '3', '7', '9', '11'])"> -->
            <w-input label="No Batch *" v-model="form.no_batch" :validators="[validators.required]" />
            <div class="spacer"></div>
            <br>
          <!-- </template> -->
            <w-input label="Nama Pengeluar Semen *" v-model="form.nama_pengeluar_s" :validators="[validators.required]"/>
            <z-select class="mt4" :items="lkp_negara" label="Negara Pengeluar Semen *" @input="pilihNegara" v-model="form.lkp_negara_id" :validators="[validators.required]"/> 
            <div class="spacer"></div>
            <br>
                  <w-button dark class="green--bg ml1" @click="KategoriNew" v-if="$zutil.role('3')" >
                      <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH KATALOG
                  </w-button>
            <z-select class="mt4" :items="se_katalog" label="ID Ternakan*" @input="pilihNoBatch" v-model="form.se_katalog_id" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input label="Nama Ternakan" v-model="form.nama_ternakan" readonly/>
            <div class="spacer"></div>
            <br>
            <w-input label="Baka" v-model="form.baka" readonly/>
            <div class="spacer"></div>
            <br>
            <!-- <w-input label="Tarikh Pengeluaran" type="date" v-model="form.tarikh_pengeluaran"/>
            <div class="spacer"></div>
            <br> -->
            <!-- <w-input label="Bilangan Straw Dikeluarkan*" type="number" v-model="form.bil_straw" :validators="[validators.required]"/> -->
            <!-- <br> -->
            <w-input label="Bilangan Straw Didaftarkan*" type="number" v-model="form.baki" :validators="[validators.required]"/>
            <br>
            <z-money class="mt4" label="Harga Perstraw (RM) *" v-model:originalValue="form.harga" :validators="[validators.required]"/>
          </div>
          
        </div>
        <w-flex class="mt3" wrap align-center justify-end>
            <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
            &nbsp;
            <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
          <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
        </w-button>
        </w-flex>
        <div class="mt2 text-left">
        <w-button bg-color="grey-light5--bg" @click="tutup">TUTUP</w-button>&nbsp;
      </div>
      </w-form>
	  </z-page>
     <w-dialog
           v-model="dialogKategori.show"
           :fullscreen="isMobile || dialogKategori.fullscreen"
           width="800"
           :persistent="dialogKategori.persistent"
           :persistent-no-animation="dialogKategori.persistentNoAnimation"
           title-class="primary-dark1--bg white">
        <template #title>
                  TAMBAH KATALOG
        </template>
        <div style="max-height: 70vh; overflow-y: auto;">
         <w-form ref="form_kategori" v-model="form_kategori.valid" @validate="validateForm" @success="success">
            <div class="w-flex wrap smd-column" >
                <div class="grow " >
                    <z-select class="mt4" :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form_kategori.lkp_ternakan_id" @input="getJurusan(form_kategori.lkp_ternakan_id)" :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan *"  v-model="form_kategori.lkp_jurusan_id" @input="getBaka(form_kategori.lkp_jurusan_id)" :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_gred" label="Generasi "  v-model="form_kategori.lkp_gred_id" />
                    <z-select class="mt4" :items="lkp_baka" label="Baka *"  v-model="form_kategori.lkp_baka_id"  :validators="[validators.required]"/>
                    <z-select class="mt4" :items="jantina" label="Jantina *"  v-model="form_kategori.jantina"  :validators="[validators.required]" disabled/>
                    
                    <br>
            
                </div>
                  <div class="mx2"></div>
                  <div class="grow " >
                    <br>
                    <w-input label="ID Ternakan *" type="text" v-model="form_kategori.kode"  :validators="[validators.required]"/>
                    <w-input class="mt4" label="Nama Ternakan " type="text" v-model="form_kategori.nama" />
                    <w-input class="mt4" label="Tarikh Lahir *" type="date" v-model="form_kategori.tarikh_lahir" :validators="[validators.required]"/>
                    <z-select class="mt4" :items="kepemilikan" label="Kepemilikan *"  v-model="form_kategori.kepemilikan"  :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_negara" label="Negara Asal *"  v-model="form_kategori.lkp_negara_id"  :validators="[validators.required]"/>
                     <z-select class="mt4" :items="lkp_status_kategori" label="Status *"  v-model="form_kategori.lkp_status_id"  :validators="[validators.required]" v-if="form_kategori.id > 0"/>
                </div>

                  <div class="mx2"></div>
                  <div class="grow " >
                    <w-input class="mt4" label="Nama Bapa" type="text" v-model="form_kategori.nama_bapa" />
                    <w-input class="mt4" label="ID Bapa" type="text" v-model="form_kategori.id_bapa" />
                    <w-input class="mt4" label="Nama Ibu" type="text" v-model="form_kategori.nama_ibu" />
                    <w-input class="mt4" label="ID Ibu" type="text" v-model="form_kategori.id_ibu" />
                    <w-textarea class="mt4"  label="Ciri-ciri"  v-model="form_kategori.ciri_ciri" />
                   
                  </div>
             </div>
         </w-form>
      </div>
        <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogKategori.show = false">TUTUP</w-button>
            <!-- <w-button class="ml1" :loading="dialogKategori.loading" :disabled="dialogKategori.valid === false" @click="$refs.form.validate()">SIMPAN</w-button> -->
            <w-button class="ml1" :loading="dialogKategori.loading" :disabled="form_kategori.valid === false" @click="$refs.form_kategori.validate()">SIMPAN</w-button>
         </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_lkp_negara : [Array, Object],
    d_se_pengeluaran : [Array, Object],
    d_se_katalog : [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.adhoc',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pendaftaran Semen Ad Hoc', route: '/se/adhoc' },
      ],
       kepemilikan: [
         {value: 1, label: "Tempatan"},
        //  {value: 2, label: "Luar Negara",}
      ],
       se_katalog: [],

      lkp_ternakan : [],
      lkp_jurusan : [],
      lkp_baka : [],
      lkp_gred : [],
      lkp_status_kategori : [],
      adhoc : [],
      jantina : [],
      title : ' Pendaftaran Ad Hoc',
      form : this.d_form,
      se_pengeluaran : this.d_se_pengeluaran,
      lkp_negara : this.d_lkp_negara,
      se_katalog : this.d_se_katalog,
      isMobile: window.innerWidth <= 768,

      form_kategori : {
                        jantina : 1
                    },
      dialogKategori: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 900,
        item: {}
      },
      
    }
  },
  methods: {
    KategoriNew(){
        this.dialogKategori.show = true;
        this.form.saveButton = "Simpan"
        this.getTernakanKategori()
        this.getGred()
        this.getStatus()
        this.getJantina()

    },
    
    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
        this.load = this.load + 1
      })
    },

    getAdhoc(){
      const roleId = this.getRoleId();
      if(roleId == '7' || roleId == '9'){
        this.adhoc = [
          {value: 1, label: "IBVK"},
          {value: 2, label: "DVS Negeri"},
        ]
      }else{
        this.adhoc = [
          {value: 1, label: "IBVK"}
        ]
      }

    },

    getTernakanKategori(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
        this.load = this.load + 1
      })
    },

    getJurusan(i){

      this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
        this.lkp_jurusan = res
        this.load = this.load + 1
      })
    },

    getBaka(i){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        this.lkp_baka = res
        this.load = this.load + 1
      })
    },

    getGred(){
      this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
        this.lkp_gred = res
        this.load = this.load + 1
      })
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status', {}).then(res => {
        this.lkp_status_kategori = res
        this.load = this.load + 1
      })
    },

    tutup(){
         this.$inertia.visit(window.route('se.adhoc.index'));
       },

     validateForm() {
      this.loading=true;
      let isValid = true;
         
      if(!this.form_kategori.lkp_ternakan_id || !this.form_kategori.lkp_jurusan_id || !this.form_kategori.lkp_baka_id || !this.form_kategori.lkp_gred_id || !this.form_kategori.jantina){
         isValid = false;
   
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah dipilih", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.submitKategori();
    },

    

    submitKategori(){
        this.form_kategori.hantar = 1;
        this.form_kategori.lkp_status_id = 1;
        this.form_kategori.jantina = 1;
        this.form_kategori.kategori = 1;
      if(this.form_kategori.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
                this.$zcomm.post('se.katalog.store' , this.form_kategori)
                .then(res => {
                  
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);

                 
                  // this.$inertia.visit(this.$route('se.katalog.show', res.id));
                     this.getKatalog();

                })
                .finally(() => {
                    this.dialogKategori.show = false;

                });
            }
          })
      }
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan_hoc/'+this.form.adhoc, {}).then(res => {
        this.se_katalog = res
        this.load = this.load + 1
      })
   },
   baki(){
      if(this.form.baki > this.form.bil_straw){
         this.form.baki = this.form.bil_straw;
      }
   },
   pilihNoBatch(value){
      for (var i in this.se_katalog) {
         if (this.form.se_katalog_id == this.se_katalog[i].value) {
            // this.form.id_ternakan = this.se_pengeluaran[i].id_ternakan;
            this.form.nama_ternakan = this.se_katalog[i].nama_ternakan;
            this.form.baka = this.se_katalog[i].baka;
            // this.form.lkp_negara_id = this.se_katalog[i].lkp_negara_id;
            // this.form.bil_straw = this.se_pengeluaran[i].jumlah_straw;
         }
      }
      // alert('asd');
   },
   pilihNegara(value){
      for (var i in this.lkp_negara) {
         if (this.form.lkp_negara_id == this.lkp_negara[i].value) {
            this.form.negara = this.lkp_negara[i].label;
         }
      }
      // alert('asd');
   },
   handleResize() {
    this.isMobile = window.innerWidth <= 768;
  },
    send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      const roleId = this.getRoleId();
      this.form.role_id = roleId;
      if (this.form.hantar==1) {
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if (this.form.id > 0) 
          {
            this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
            .then(res => {
              if (typeof this.onAfterEdit === "function") {
                this.onAfterEdit()
              }
              this.$inertia.visit(this.$route('se.adhoc.show', this.form.id))
            })
          }
          else 
          {
            this.$zcomm.post(this.resourceurl+'.store' , this.form)
            .then(res => {
              if (typeof this.onAfterAdd === "function") {
                this.onAfterAdd()
              }
            this.$zutil.notify("Berjaya dihantar", true);
              this.$inertia.visit(this.$route('se.adhoc.show', res.id))

            })
          }
        }else{ }
        })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('se.adhoc.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('se.adhoc.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('se.adhoc.form', res.id));
            // this.$inertia.visit(this.$route('se.pemungutan.show', res.id))

          })
        }
      }
    },
    getRoleId() {
      const params = new URLSearchParams(window.location.search)
      return params.get('role_id')
    },



    
  
  },

  watch: {

  },
  mounted() {
    if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh = today.toISOString().split('T')[0];
    }
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Pendaftaran Semen Ad Hoc'
    }
    else
    {
      this.title = 'Tambah Pendaftaran Semen Ad Hoc'
    }
    this.getAdhoc();
    window.addEventListener('resize', this.handleResize);
},

    
}
</script>
